var _rect, _circle, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "#E8E4E0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 35,
    fill: "#C4BEB8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 170,
    rx: 55,
    ry: 45,
    fill: "#C4BEB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderAvatar);
export default __webpack_public_path__ + "static/media/placeholder-avatar.27c423269dae7c02037bd894793c1562.svg";
export { ForwardRef as ReactComponent };